import { Box, BoxProps, Typography } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const ControlsOverlay = styled(Box)(({ theme }) => ({
  inset: 0,
  opacity: 1,
  pointerEvents: "auto",
  position: "absolute",
  transition: "opacity .3s linear",
  zIndex: 2,

  "&::before": {
    background: theme.linearGradients.gradientC,
    content: "''",
    inset: 0,
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0
  }
}));

export const CenterButton = styled("button")(({ theme }) => ({
  alignItems: "center",
  backgroundColor: `${alpha(theme.customColors.systemPrimary01, 0.25)} !important`,
  border: "none",
  borderRadius: "0.75rem",
  cursor: "pointer",
  display: "flex",
  height: "3rem",
  justifyContent: "center",
  left: "50%",
  padding: "0.5625rem",
  position: "absolute",
  top: "50%",
  transform: "translate(-50%, -50%)",
  width: "3rem",
  zIndex: 1,

  "&:focus-visible": {
    outline: `4px solid ${theme.customColors.systemSecondary01}`,
    outlineOffset: "4px"
  }
}));

export const BottomControlsBar = styled(Box)(() => ({
  bottom: "1.5rem",
  display: "flex",
  flexDirection: "column",
  gap: "0.75rem",
  left: "1.5rem",
  position: "absolute",
  right: "1.5rem",
  zIndex: 1
}));

export const ProgressBarHitArea = styled(Box)(() => ({
  cursor: "pointer",
  padding: "6px 0",
  width: "100%"
}));

export const ProgressBarTrack = styled(Box)<BoxProps & { $disabled?: boolean }>(({ theme, $disabled }) => ({
  backgroundColor: theme.customColors.border,
  borderRadius: "999px",
  height: "4px",
  opacity: $disabled ? 0.5 : 1,
  pointerEvents: $disabled ? "none" : "auto",
  position: "relative",
  width: "100%"
}));

export const ProgressBarFill = styled(Box)<BoxProps & { $value: number }>(({ theme, $value }) => ({
  backgroundColor: theme.customColors.systemSecondary01,
  borderRadius: "999px",
  bottom: 0,
  left: 0,
  position: "absolute",
  top: 0,
  width: `${$value}%`
}));

export const ProgressBarThumb = styled(Box)<BoxProps & { $value: number }>(({ theme, $value }) => ({
  backgroundColor: theme.customColors.systemSecondary01,
  borderRadius: "50%",
  height: "12px",
  left: `${$value}%`,
  pointerEvents: "none",
  position: "absolute",
  top: "50%",
  transform: "translate(-50%, -50%)",
  width: "12px"
}));

export const ControlsRow = styled(Box)(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between"
}));

export const ControlsGroupLeft = styled(Box)(() => ({
  alignItems: "center",
  display: "flex",
  gap: "0.75rem"
}));

export const ControlsGroupRight = styled(Box)(() => ({
  alignItems: "center",
  display: "flex",
  gap: "1rem"
}));

export const SmallControlButton = styled("button")(({ theme }) => ({
  alignItems: "center",
  backgroundColor: `${alpha(theme.customColors.systemPrimary01, 0.25)} !important`,
  border: "none",
  borderRadius: "0.5rem",
  cursor: "pointer",
  display: "flex",
  height: "2rem",
  justifyContent: "center",
  padding: 0,
  width: "2rem",
  "svg": {
    height: "2rem"
  },
  "&:focus-visible": {
    outline: `4px solid ${theme.customColors.systemSecondary01}`,
    outlineOffset: "4px"
  }
}));

export const CaptionsControlWrapper = styled(Box)(() => ({
  position: "relative"
}));

export const CaptionsMenu = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.customColors.systemPrimary01, 0.9),
  borderRadius: "0.75rem",
  bottom: "calc(100% + 0.5rem)",
  display: "flex",
  flexDirection: "column",
  gap: "0.25rem",
  padding: "0.375rem",
  position: "absolute",
  right: 0,
  zIndex: 3
}));

export const CaptionsMenuItem = styled("button")<{ $active?: boolean }>(({ theme, $active }) => ({
  backgroundColor: $active ? theme.customColors.systemSecondary01 : "transparent",
  border: "none",
  borderRadius: "0.5rem",
  color: $active ? theme.customColors.systemPrimary01 : theme.customColors.textPrimary,
  cursor: "pointer",
  fontSize: "0.875rem",
  padding: "0.5rem 1rem",
  textAlign: "center",
  whiteSpace: "nowrap",

  "&:hover": {
    backgroundColor: $active ? theme.customColors.systemSecondary01 : alpha(theme.customColors.systemPrimary01, 0.5)
  },

  "&:focus-visible": {
    outline: `2px solid ${theme.customColors.systemSecondary01}`,
    outlineOffset: "2px"
  }
}));

export const TimestampText = styled(Typography)(({ theme }) => ({
  color: theme.customColors.exploreCardText,
  fontSize: "0.875rem",
  whiteSpace: "nowrap"
}));
